import { render } from "./WalkDetailView.vue?vue&type=template&id=312d94fc&scoped=true"
import script from "./WalkDetailView.vue?vue&type=script&lang=js"
export * from "./WalkDetailView.vue?vue&type=script&lang=js"

import "./WalkDetailView.vue?vue&type=style&index=0&id=312d94fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312d94fc"]])

export default __exports__